export default __webpack_public_path__ + "static/media/game_icon6.4b71efb4.png";